module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Aex.a9483342.png";